import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { CATEGORIES, FORMATS, SIZES } from '@/enums/components'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import BaseIcon from '@/components/BaseIcon.vue'
import { PropType, computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  label: {
    type: String,
    default: null,
  },
  format: {
    type: String as PropType<FORMATS>,
    default: FORMATS.PRIMARY,
  },
  category: {
    type: String as PropType<CATEGORIES>,
    default: '',
  },
  size: {
    type: String as PropType<SIZES>,
    default: SIZES.MEDIUM,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hidden: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  target: {
    type: [String, Object] as PropType<RouteLocationRaw>,
    default: null,
  },
  iconRight: {
    type: Boolean,
    default: false,
  },
  iconSize: {
    // If not specified it will default to size based value in computedIconSize
    type: Number,
    default: undefined,
  },
  setMinWidth: {
    type: Boolean,
    default: undefined,
  },
},
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const props = __props





const computedIconSize = computed<number>(() => {
  // Defaults for different sizes
  const iconSizes: { [key: string]: number } = {
    [SIZES.SMALL]: 16,
    [SIZES.MEDIUM]: 32,
    [SIZES.LARGE]: 32,
  }
  return props.iconSize || iconSizes[props.size] || 32
})

const onClick = (event: Event) => {
  if (!props.disabled && !props.loading) {
    emits('onClick', event)
  }
  if (event) {
    const target = event.target as HTMLElement
    target.blur()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.target ? 'router-link' : 'button'), _mergeProps({
    to: __props.target,
    class: {
      btn: true,
      [`btn--${__props.format}`]: __props.format,
      [`btn--${__props.category}`]: __props.category,
      [`btn--${__props.size}`]: __props.size,
      'btn--disabled': __props.disabled,
      'btn--hidden': __props.hidden,
      'btn--loading': __props.loading,
      'btn--icon-right': __props.iconRight,
      'btn--min-width': __props.setMinWidth,
    },
    disabled: __props.disabled
  }, _ctx.$attrs, { onClick: onClick }), {
    default: _withCtx(() => [
      (__props.icon && !__props.loading)
        ? (_openBlock(), _createBlock(BaseIcon, {
            key: 0,
            icon: __props.icon,
            size: _unref(computedIconSize)
          }, null, 8, ["icon", "size"]))
        : _createCommentVNode("", true),
      (__props.loading && __props.icon)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 1 }))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.label) + " ", 1),
      _renderSlot(_ctx.$slots, "default"),
      (__props.loading && !__props.icon)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["to", "class", "disabled"]))
}
}

})